const modalEditPhotoModalEquipServiceQuest = {
  title: 'Edit question photo'
};

export default modalEditPhotoModalEquipServiceQuest;
